import { FormFieldValidation } from '@moia-dev/pace-web'
import {
  Controller,
  type ControllerProps,
  type FieldValues,
} from 'react-hook-form'
import { Selectfield, SelectfieldOption, type SelectfieldProps } from '../Basic'

export type FormSelectfieldProps<
  FormFieldValues extends FieldValues,
  Value,
> = Omit<SelectfieldProps<Value>, 'onChange' | 'value'> &
  Pick<
    ControllerProps<FormFieldValues>,
    'control' | 'name' | 'rules' | 'disabled'
  >

export const FormSelectfieldOption: typeof SelectfieldOption = SelectfieldOption

export const FormSelectfield = <FormFieldValues extends FieldValues, Value>({
  disabled,
  name,
  control,
  rules,
  caption,
  label,
  ...props
}: FormSelectfieldProps<FormFieldValues, Value>) => (
  <Controller
    control={control}
    name={name}
    rules={rules}
    render={({ field: { value, onChange }, fieldState }) => (
      <Selectfield
        value={value}
        onChange={onChange}
        required={Boolean(rules?.required)}
        caption={caption}
        validation={
          fieldState.error?.message && (
            <FormFieldValidation type="error">
              {fieldState.error.message}
            </FormFieldValidation>
          )
        }
        label={label}
        error={Boolean(fieldState.error?.type)}
        disabled={disabled}
        {...props}
      />
    )}
  />
)
